import { render, staticRenderFns } from "./UserBoxItem.vue?vue&type=template&id=3960232d&"
import script from "./UserBoxItem.vue?vue&type=script&lang=ts&"
export * from "./UserBoxItem.vue?vue&type=script&lang=ts&"
import style0 from "./UserBoxItem.vue?vue&type=style&index=0&id=3960232d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports